import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Platform }         from 'ionic-angular';
import { AngularFire, AuthProviders,
    AuthMethods} from 'angularfire2';
import firebase from 'firebase';
import {FaceBookService}        from './facebook-provider';
import { Router} from '@angular/router';   

declare var window: any;



@Injectable()
export class UserService {
    loginStatus: string = 'start';
    userStatus: any = {
        'displayName'   :   'Fetching user Details....',
        'photoURL':   '../assets/images/User-placeholder.png'
    };
    constructor(
        public http: Http,
        private platform: Platform,
        public af: AngularFire,
        private faceBookService: FaceBookService,
        private router: Router
    ) {
        var that = this;
        this.af.auth.subscribe(user => {
            if (user == null) {
                that.loginStatus = "start";                
                return;
            }
            console.log(user);
            if (user.provider == 5) {                                
                that.userStatus.displayName = '';
                that.userStatus.photoURL = '../assets/images/User-placeholder.png';
                that.loginStatus = "login";                
                that.router.navigate(['login']);
            } else {
                that.userStatus.displayName = user.auth.displayName;
                that.userStatus.photoURL = user.auth.photoURL;
                that.loginStatus = "profile";
                that.router.navigate(['app']);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/feature/loginModule/providers/userService-provider.ts